module.exports = __webpack_public_path__ + "static/media/WavelengthTable.7b616161.png";